import { Link, useLocation } from "react-router-dom";
import { FoundUserSvg } from "../../components/Assets";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import TopPageBack from "../../components/TopPageBack";
import { ROUTE_PATHS } from "../../constants/Router";

const ChangePasswordResult = function () {
  const location = useLocation()
  const state = location.state
  return (
    <div>
      <TopPageBack>
        <b>비밀번호 재설정</b>
      </TopPageBack>
      <div
        className="flex justify-center items-center "
        style={{
          height: "calc(100vh - 100px)",
        }}
      >
        <div className="flex items-center justify-center flex-col px-5 w-full">
          <img src={FoundUserSvg} />
          <div className="mt-5 mb-6">비밀번호 수정이 완료되었습니다.</div>
          <div className="user-badge text-center">
            {state?.password}
          </div>
        </div>
      </div>

      <div className="px-5 absolute w-full bottom-2 left-0">
        <Link to={ROUTE_PATHS.FindId}>
          <div className="text-center text-datesub">아이디 찾기</div>
        </Link>

        <Link to={ROUTE_PATHS.SignIn}>
          <SolidBlueBtn className="w-full mt-7" type="submit">
            로그인 하러 가기
          </SolidBlueBtn>
        </Link>
      </div>
    </div>
  );
};
export default ChangePasswordResult;
